import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import PopularGrid from './components/PopularGrid';
import ReviewSection from './components/ReviewSection';
import SideContent from './components/SideContent';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/comics';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <PopularGrid />
        <SideContent />
        <ReviewSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '虚空韩漫网',
            url: 'http://metcw.com/',
            description: '虚空韩漫网提供正版韩漫大全和免费韩漫下拉式阅读体验，涵盖热血、恋爱、悬疑、奇幻等多种类型。',
            email: 'hello@metcw.com',
            telephone: '+86-400-888-6666',
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              streetAddress: '望京SOHO T1 18层',
            },
            sameAs: ['http://metcw.com/'],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '虚空韩漫网',
            url: 'http://metcw.com/',
            description: '虚空韩漫网 - 正版韩漫大全，提供免费韩漫下拉式在线漫画阅读体验。',
            inLanguage: 'zh-CN',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'http://metcw.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '虚空韩漫网 - 正版韩漫大全',
            description: '虚空韩漫网提供正版韩漫大全和免费韩漫下拉式阅读体验，在尊重版权的同时服务广大漫画爱好者。',
            inLanguage: 'zh-CN',
            isPartOf: {
              '@type': 'WebSite',
              name: '虚空韩漫网',
              url: 'http://metcw.com/',
            },
          }),
        }}
      />
    </>
  );
}